import { defineComponent as y, inject as w, ref as L, onMounted as p, h as s, Transition as E, nextTick as x } from "vue";
import { notificationProviderInjectionKey as T } from "./ghl-ui.es1061.js";
import { notificationProps as F, Notification as O, notificationPropKeys as j } from "./ghl-ui.es1373.js";
import { keep as C } from "./ghl-ui.es930.js";
const M = Object.assign(Object.assign({}, F), {
  duration: Number,
  onClose: Function,
  onLeave: Function,
  onAfterEnter: Function,
  onAfterLeave: Function,
  /** @deprecated */
  onHide: Function,
  /** @deprecated */
  onAfterShow: Function,
  /** @deprecated */
  onAfterHide: Function
}), K = y({
  name: "NotificationEnvironment",
  props: Object.assign(Object.assign({}, M), {
    // private
    internalKey: {
      type: String,
      required: !0
    },
    onInternalAfterLeave: {
      type: Function,
      required: !0
    }
  }),
  setup(n) {
    const {
      wipTransitionCountRef: a
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = w(T), f = L(!0);
    let i = null;
    function o() {
      f.value = !1, i && window.clearTimeout(i);
    }
    function u(e) {
      a.value++, x(() => {
        e.style.height = `${e.offsetHeight}px`, e.style.maxHeight = "0", e.style.transition = "none", e.offsetHeight, e.style.transition = "", e.style.maxHeight = e.style.height;
      });
    }
    function h(e) {
      a.value--, e.style.height = "", e.style.maxHeight = "";
      const {
        onAfterEnter: t,
        onAfterShow: r
      } = n;
      t && t(), r && r();
    }
    function d(e) {
      a.value++, e.style.maxHeight = `${e.offsetHeight}px`, e.style.height = `${e.offsetHeight}px`, e.offsetHeight;
    }
    function l(e) {
      const {
        onHide: t
      } = n;
      t && t(), e.style.maxHeight = "0", e.offsetHeight;
    }
    function c() {
      a.value--;
      const {
        onAfterLeave: e,
        onInternalAfterLeave: t,
        onAfterHide: r,
        internalKey: H
      } = n;
      e && e(), t(H), r && r();
    }
    function v() {
      const {
        duration: e
      } = n;
      e && (i = window.setTimeout(o, e));
    }
    function m(e) {
      e.currentTarget === e.target && i !== null && (window.clearTimeout(i), i = null);
    }
    function g(e) {
      e.currentTarget === e.target && v();
    }
    function A() {
      const {
        onClose: e
      } = n;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && o();
      }) : o();
    }
    return p(() => {
      n.duration && (i = window.setTimeout(o, n.duration));
    }), {
      show: f,
      hide: o,
      handleClose: A,
      handleAfterLeave: c,
      handleLeave: l,
      handleBeforeLeave: d,
      handleAfterEnter: h,
      handleBeforeEnter: u,
      handleMouseenter: m,
      handleMouseleave: g
    };
  },
  render() {
    return s(E, {
      name: "notification-transition",
      appear: !0,
      // convert to any since Element is not compatible with HTMLElement
      onBeforeEnter: this.handleBeforeEnter,
      onAfterEnter: this.handleAfterEnter,
      onBeforeLeave: this.handleBeforeLeave,
      onLeave: this.handleLeave,
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => this.show ? s(O, Object.assign({}, C(this.$props, j), {
        onClose: this.handleClose,
        onMouseenter: this.duration && this.keepAliveOnHover ? this.handleMouseenter : void 0,
        onMouseleave: this.duration && this.keepAliveOnHover ? this.handleMouseleave : void 0
      })) : null
    });
  }
});
export {
  K as NotificationEnvironment,
  M as notificationEnvOptions
};
